import { useAppSelector } from '@/redux/hooks'
import { useTranslate } from '@/hooks'
import { LanguageSelect } from '@/app/login/language-select'
import { PortalFooter } from '@/ui/layout/portal-footer'
import { LoginForm } from './login-form'
import { TermsAndConditions } from './terms-and-conditions'

export const SimplifiedLoginLayout = ({
  children
}: {
  children?: React.ReactNode
}) => {
  const { translate } = useTranslate()

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  const logoUrl = settings.branding?.logo_url
  const title = settings.branding?.title
  const desktopLogoHeight = settings.branding?.logo_height_desktop
  const mobileLogoHeight = settings.branding?.logo_height_mobile

  return (
    <div className="flex h-dvh flex-col items-center justify-between p-4">
      <div className="ml-auto w-32">
        <LanguageSelect />
      </div>
      <div className="-mt-5 flex size-full max-w-[26rem] flex-1 flex-col items-center justify-center gap-5">
        {children ?? (
          <>
            <header className="mb-2 space-y-2 text-center">
              <h1
                className="text-lg font-bold [text-wrap:balance]"
                dangerouslySetInnerHTML={{
                  __html: translate('landing_title_layout_simplified')
                }}
              />
              <h2
                className="mx-auto max-w-[22rem] text-sm font-normal [text-wrap:pretty]"
                dangerouslySetInnerHTML={{
                  __html: translate('landing_subtitle')
                }}
              />
            </header>
            <LoginForm />
          </>
        )}
        <div className="flex flex-col items-center justify-center gap-10">
          {children ? null : <TermsAndConditions />}
          {logoUrl ? (
            <div className="mx-auto">
              <img
                style={
                  {
                    '--logo-desktop-height': desktopLogoHeight ?? '4rem',
                    '--logo-mobile-height': mobileLogoHeight ?? '2rem'
                  } as React.CSSProperties
                }
                width={285}
                height={70}
                src={logoUrl}
                alt={title}
                className="h-[var(--logo-mobile-height)] w-auto object-contain md:h-[var(--logo-desktop-height)]"
              />
            </div>
          ) : null}
        </div>
      </div>
      <PortalFooter />
    </div>
  )
}
